import React, {useRef, useState} from 'react'
import Header from '../general/Header'
import SubHeader from '../general/SubHeader'
import Copyright from '../general/Copyright'
import emailjs from '@emailjs/browser';

const AccountDelete = () => {
      const [response, setResponse] = useState(null);
const [loading, setLoading] = useState(false);

    const form = useRef();

    const sendEmail = (e) => {
        setLoading(true);
      e.preventDefault();
  
      emailjs
        .sendForm('service_kcmstore', 'template_contact', form.current, {
          publicKey: 'bU25sqIPXDYEBoiz4',
        })
        .then(
          () => {
            setLoading(false);
            console.log('Form Submitted!');
            setResponse('Your Form has been Submitted Successfully!');
            setTimeout(() => {
                setResponse('');
              }, 3000);
              form.current.reset();
          },
          (error) => {
            setLoading(false);
            console.log('FAILED...', error.text);
          },
        );
    };


  return (
    <>
                        <Header />

<SubHeader message="Request Account Deletion" />



<section className='my-5'>
    <div className='container'>

    <p className='sec-heading my-0'>Request Account Deletion</p>
    <p className='fw-semibold text-muted'>Fill the form below. Your account will be deleted within 15 business days.</p>

<form class="row g-3 mt-4" ref={form} onSubmit={sendEmail}>

    <div class="col-12 contact-label-area my-3">
    <label for="inputName" class="contact-label">Your Name</label>
    <input type="text" class="contact-control" name='user_name' id="inputName" />
  </div>

  <div class="col-12 contact-label-area my-3">
    <label for="inputPhone" class="contact-label">Mobile Number</label>
    <input type="tel" class="contact-control" name='user_mobile' id="inputPhone" />
  </div>

  <div class="col-12 contact-label-area my-3">
    <label for="inputEmail4" class="contact-label">Email</label>
    <input type="email" class="contact-control" name='user_email' id="inputEmail4" />
  </div>

  <div class="col-12 contact-label-area my-3">
    <label for="inputDescription" class="contact-label">Description</label>
    <textarea type="text" class="contact-control" name='message' id="inputDescription" placeholder='Provide your Account Details to request for Deletion. Why you want to delete this account?' style={{height: '10em'}}></textarea>
  </div>


  <div class="col-12 text-end">
    <button type="submit" class="login-btn2">Submit</button>
  </div>
</form>



    </div>
</section>


<Copyright />

    </>
  )
}

export default AccountDelete
